import React from "react";
import { TableRow, TableCell, Checkbox, makeStyles } from "@material-ui/core"
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
const useStyles = makeStyles({
  customTable: {
    "& .MuiTableCell-alignLeft": {
      padding: "0px 0px 0px 0px",
    },
  },
});
export const BankRow = ({
  isItemSelected,
  row,
  openActionMenu,
  actionButtonClass,
  defaultAccountsData
}) => {
  const classes = useStyles();

  return (
    <TableRow
      className={{root: classes.customTable}}
      hover
      style={{ padding: "3px 0px", borderBottom: '1px solid lightgray' }}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.name}
      selected={isItemSelected}
    >
      <TableCell padding="none">
      </TableCell>
      <TableCell align="left"style={{fontWeight:500}}>{row["banksLean"].name}</TableCell>
      <TableCell align="left"style={{fontWeight:500}}>{row["bankSwiftCode"]}</TableCell>
      <TableCell align="left"style={{fontWeight:500}}>{row["bankAddress"]}</TableCell>
      <TableCell align="left" style={{ textTransform: "capitalize", fontWeight:500 }}>
        {row["accountNumber"]}
      </TableCell>
      <TableCell align="left"style={{fontWeight:500}}>{row["accountTitle"]}</TableCell>
      <TableCell align="left"style={{fontWeight:500}}>{row["accountIban"]}</TableCell>
      <TableCell align="left"style={{fontWeight:500}}>{defaultAccountsData[0]?.defaultLeanBankAccount === row["id"] ? <CheckIcon /> : <ClearIcon />}</TableCell>
      <TableCell align="left"style={{fontWeight:500}}>
        <div
          role="presentation"
          onClick={(e) => {
            openActionMenu(e, row);
          }}
          className={actionButtonClass}
        >
          <MoreHorizIcon />
        </div>
      </TableCell>
    </TableRow>
  );
};
